import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import ui from "@/assets/scripts/ui";

export default {
    crudGeneral,
    data() {
        return {
            command: 'insert',
            status: "",
            genKey: false, //Por padrão os formulários não possuem gerador de chave temporária
            fieldKey: "",
            form: {},
            generalErrors: [],
            pageFormIsLoaded: false,
            checkErrorsComponent: false,
            submitExternal: "",
        }
    },
    props: {
        /*Utilizada quando o formulário se torna um objeto Embeddable*/
        enabledSubmit: {
            type: Boolean,
            default: true,
        },
    },
    async mounted() {


    },
    methods: {

        async injectFieldsForm() {
            //Injeta campos customizaveis caso necessário na entidade
            if (this.fieldsCustomizable.length > 0) {

                let requestCustomized = []

                for (const entity of this.fieldsCustomizable) {
                    if (entity.fields !== null)
                        requestCustomized.push(await this.requestFieldCustomized(entity.entity, entity.fields))
                }

                this.form.requestCustomized = requestCustomized

            }
        },


        /*ATENÇÃO ESTE AQUI É DIFERENTE POIS É ACESSADO VIA EMBEDABLES*/
        setFieldValue(entity, fieldId, value) {

            if (this.fieldsCustomizable !== undefined) {

                let entityField = this.fieldsCustomizable.find(a => a.entity === entity)

                if (entityField !== undefined) {

                    let field = entityField.fields.find(a => a.fieldId === fieldId)

                    if (field !== undefined) {

                        field.value = value
                        entityField.fields.push(field)
                        entityField.fields.pop()

                    }

                }

            }

        },

        onSubmitExternal() {

            this.submitExternal = ""

            setTimeout(() => {

                this.submitExternal = "submit"

            }, 100)

            setTimeout(() => {

                this.submitExternal = ""

            }, 200)


        },


        cancelUpdatedList() {
            this.command = 'insert'
            this.resetFormDefault(this.form, this.fieldsNotReset)
            this.clearFieldsCustomizable()
            this.defaultForm()
        },

        /**Utilizado para setar de algum componente externo os valores padrões do formulário de campos customizados*/



        //Limpar o formulário de forma padrão, porém é opcional a chamada

        async mountedForm(defaultValidation = true, finishLoaded = true, formInnerComponent = false) {

            await this.mountedDefault(defaultValidation, true, 'form')

            if (!formInnerComponent)//Utilizando por exemplo dentro de Tabs
                await this.setInitiate()

            if (defaultValidation) {
                //Utilizado a validação padrão de formulários
                this.setValidationDefault(this.userAuth.validation)
            }


            if (this.genKey && this.isInsert()) {

                await crudGeneral.get(this.getPath() + "/createId").then(
                    response => {


                        this.form[this.fieldKey] = response.data.id
                        this.genKey = false //Indica que a chave já foi criada
                    }
                ).catch(error => this.responseError(error))

            }

            //Obtem campos personalizáveis de inicialização, porém ao alterar os valores chave, poderá ser solicitado novamente a requisição
            /*LER SOMENTE AQUI, POIS PRECISA TER LIDO A ENTIDADE PRINCIPAL PARA INJETAR OS VALORES CORRESPONDENTES*/
            await this.getAllFieldsCustomizable();

            if (finishLoaded)
                this.pageFormIsLoaded = true

        },

        async clearFieldsCustomizable() {

            if (this.fieldsCustomizable.length > 0) {

                for (const entity of this.fieldsCustomizable) {

                    for (let field of entity.fields) {
                        field.value = null
                    }

                }

            }


        },

        async getAllFieldsCustomizable() {

            if (this.fieldsCustomizable.length > 0) {

                for (const entity of this.fieldsCustomizable) {
                    await this.getFieldsCustomizable(entity.entity)
                }

            }

        },


        async setInitiate(updateCommand = true) {


            let getItem = true

            if (this.$route.path.indexOf('/view/') > 0) {

                if (updateCommand)
                    this.command = "view"

            } else if (this.$route.path.indexOf('/remove/') > 0) {

                if (updateCommand)
                    this.command = 'delete'

            } else {

                if ('id' in this.$route.params) {

                    if (updateCommand)
                        this.command = 'update'

                } else {

                    if (updateCommand)
                        this.command = 'insert'
                    getItem = false
                }

            }

            if (getItem && this.command !== 'insert') {

                //Crud enviado por tanto será um get padrão por id
                await crudGeneral.getById(this.getPath(), this.$route.params.id).then(
                    response => this.form = response.data
                ).catch(error => this.responseError(error))
            }

        },

        setValidationDefault(validation) {

            if (this.isInsert() && !validation.validationCreate) {
                this.setRedirect(this.getPath(), 0, this.command, 11, "", false)
            } else if (this.isUpdate() && !validation.validationUpdate) {
                this.setRedirect(this.getPath(), 0, this.command, 12, "", false)
            } else if (this.command === 'delete' && !validation.validationDelete) {
                this.setRedirect(this.getPath(), 0, this.command, 13, "", false)
            } else if (this.command === "view" && !validation.validationRead) {
                this.setRedirect(this.getPath(), 0, this.command, 14, "", false)
            }

        },


        async setSendingDefault(callbackError) {

            const id = this.form[this.fieldKey]

            await this.setSending(
                id,
                (response) => {
                    this.setRedirect(this.getPath(), response[this.fieldKey], this.command, 0, "", true)
                },
                (response) => {
                    this.setRedirect(this.getPath(), response[this.fieldKey], this.command, 0, "", true)
                }, (response) => {
                    this.setRedirect(this.getPath(), response[this.fieldKey], this.command, 0, "", true)
                },
                callbackError
            )

        },

        async setSending(id, callbackSuccess, callbackSuccessUpdate, callbackSuccessDelete, callbackError) {

            this.status = "sending"
            this.checkErrorsComponent = false

            //Limpa campos de erros (caso existam)
            if (this.error !== undefined) {
                Object.keys(this.error).forEach(key => {
                    this.error[key] = ""
                })
            }


            await this.injectFieldsForm()
            delete this.form.fieldsCustomized //Remove o quest original antes do envio oficial


            if (this.command === 'delete') {

                await crudGeneral.remove(this.getPath(), id).then(response => {

                    if (callbackSuccessDelete !== undefined) {
                        callbackSuccessDelete(response.data)
                    } else {
                        //Utilizar callbackpadrão, pois não foi declarado
                        callbackSuccess(response.data)
                    }

                }).catch(error => this.responseError(error, callbackError))


            } else {

                //Crud enviado, por tanto será feito de forma automatica a inclusão e alteração
                await crudGeneral.save(this.getPath(), this.command, this.form).then(response => {

                    const data = response.data

                    if (this.isInsert()) {
                        callbackSuccess(data)
                    } else if (this.isUpdate()) {

                        if (callbackSuccessUpdate !== undefined) {
                            callbackSuccessUpdate(data)
                        } else {
                            //Utilizar callbackpadrão, pois não foi declarado
                            callbackSuccess(data)
                        }
                    }

                }).catch(error => this.responseError(error, callbackError))

            }

        },

        async onItemReadDefault(id, callback) {

            this.listFormIsLoaded = false

            await crudGeneral.getById(this.path, id).then(
                async (response) => {

                    this.command = 'update'
                    this.form = response.data

                    //Obtem campos personalizáveis de inicialização, porém ao alterar os valores chave, poderá ser solicitado novamente a requisição
                    /*LER SOMENTE AQUI, POIS PRECISA TER LIDO A ENTIDADE PRINCIPAL PARA INJETAR OS VALORES CORRESPONDENTES*/
                    await this.getAllFieldsCustomizable();

                    this.listFormIsLoaded = true

                    if (callback)
                        callback()
                }
            ).catch(error => this.responseError(error))

        },

        async onItemDeleteDefault(id, callback) {


            await crudGeneral.remove(this.path, id).then(
                () => {

                    this.actionDefaultAfterCRUD()

                    if (callback)
                        callback()
                }
            ).catch(error => ui.generalResponseError(this, error))

        },


        responseError(error, callback = null) {


            //Retorna o status para o padrão de tentativa de subject enviado
            this.status = "subject"
            this.generalErrors = [] //Limpa os erros para poder atualiza-los novamente

            if (error.response) {

                if (error.response.status === 500) {

                    if (error.response.data instanceof Blob) {

                        const b = new Blob([error.response.data], {type: "application/json"}),
                            fr = new FileReader();

                        fr.onload = e => {

                            const objectError = JSON.parse(e.target.result)

                            if (error.response.status === 500) {
                                ui.msgError(this, objectError.general[0], callback)
                            }

                        }

                        fr.readAsText(b);

                    } else {

                        const general = error.response.data.general
                        const fields = error.response.data.fields

                        if (general && general.length > 0) {
                            this.generalErrors = general
                        }

                        Object.keys(fields).forEach(key => {

                            if (key.indexOf(".") > 0) {

                                const obj = key.substring(0, key.indexOf("."))
                                const objField = key.replace(obj + ".", '')

                                if ([objField] in this["error_" + obj]) {

                                    //Limpa antes para poder enviar alerta de atualização e mesmo recebendo novamente o mesmo erro irá exibir
                                    this["error_" + obj][objField] = ""

                                    //Seta informaçao com delay para possibilitar limpeza do campo anterior
                                    setTimeout(() => this["error_" + obj][objField] = fields[key], 50)


                                } else {
                                    alert('Falha encontrada campo relacionado: ' + key + ' - ' + fields[key])
                                }

                                //console.log("Objeto [" + obj + "]")
                                //console.log("Field [" + objField + "]")

                            } else {

                                if ([key] in this.error) {

                                    //Limpa antes para poder enviar alerta de atualização e mesmo recebendo novamente o mesmo erro irá exibir
                                    this.error[key] = ""

                                    //Seta informaçao com delay para possibilitar limpeza do campo anterior
                                    setTimeout(() => this.error[key] = fields[key], 50)

                                } else {
                                    alert('Falha encontrada campo: ' + key + ' - ' + fields[key])
                                }

                            }

                        });

                        //Marca para os componentes de formulario realizarem nova verificação interna (usado principalmente em Tabs)
                        this.checkErrorsComponent = true

                        if (callback)
                            callback(general)

                    }


                    //-----------------------------------------------------------------------------------------------------------


                } else if (error.response.status === 400) {

                    alert('Falha ao tentar enviar, por favor tente novamente ou informe nosso suporte técnico o seguinte erro: 400')
                    console.warn(error.response);

                }

            } else if (error.request) {
                // The request was made but no response was received
                alert('Falha de conexão, verifique sua internet 4')
                console.warn(error.request);
            }

        },

        /*MÉTODOS USADOS EM COMPONENTES RESOURCE MÉTODOS*/
        getEmbedAddressApi(el, address) {

            this.form[el].street = address.street
            this.form[el].neighborhood = address.neighborhood
            this.form[el].provinceAbbreviation = address.provinceAbbreviation
            this.form[el].cityId = address.cityId

        },

        getEmbedCNPJApi(elPerson, elAddress, cnpjAPI) {

            //Person
            if (cnpjAPI.person.name != null) {
                this.form[elPerson].name = cnpjAPI.person.name.toUpperCase()
            } else if (cnpjAPI.person.companyName != null) {
                //Utiliza o mesmo nome da razão social
                this.form[elPerson].name = cnpjAPI.person.companyName.toUpperCase()
            }

            this.form[elPerson].companyName = cnpjAPI.person.companyName
            this.form[elPerson].federalTaxpayer = cnpjAPI.person.federalTaxpayer
            this.form[elPerson].otherPersonalDocument = cnpjAPI.person.otherPersonalDocument
            this.form[elPerson].provinceTaxpayer = cnpjAPI.person.provinceTaxpayer
            this.form[elPerson].provinceTaxpayerExempted = cnpjAPI.person.provinceTaxpayerExempted

            if (this.form[elPerson].companyName !== null)
                this.form[elPerson].companyName = this.form[elPerson].companyName.toUpperCase()

            if (cnpjAPI.person.cityTaxpayer !== null)
                this.form[elPerson].cityTaxpayer = cnpjAPI.person.cityTaxpayer

            if (this.form.invoiceEmail !== null)
                this.form.invoiceEmail = cnpjAPI.invoiceEmail

            if (this.form.invoiceBRSuframa !== null)
                this.form.invoiceBRSuframa = cnpjAPI.invoiceBRSuframa

            //---------------------------------------

            //Address
            this.form[elAddress].street = cnpjAPI.address.street
            this.form[elAddress].number = cnpjAPI.address.number
            this.form[elAddress].complement = cnpjAPI.address.complement
            this.form[elAddress].neighborhood = cnpjAPI.address.neighborhood
            this.form[elAddress].provinceAbbreviation = cnpjAPI.address.provinceAbbreviation
            this.form[elAddress].cityId = cnpjAPI.address.cityId
            this.form[elAddress].zipcode = cnpjAPI.address.zipcode
            //---------------------------------------

        },
        /*-------------------------------------------------------------*/

    },
    computed: {

        onSending() {
            //Utilizado em inputs diretos no próprio formulário ao invés de usado no componente validation-input
            return this.status === "sending"
        },

    },
    watch: {

        /*fieldsCustomizable(v){
            console.log(v)
        },*/


    }
}




